import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '@/utils/amplitude/experiments/utils/useAmplitudeExperimentBase';

export const useHomePageRedesignExperiment = () =>
    useAmplitudeExperimentBase(AmplitudeExperiments.HomePageRedesign, AmplitudeVariants.HomePageRedesign.Treatment);
